import React from 'react';
import TnCData from './SignupAgreementData.json';
import styles from './SignupAgreement.module.css';

const MktAgreement = (props) => {
  const handlePopupClick = (e) => {
    props.onClick(e);
  };

  return (
    <div className={styles.mktAgreementtLayer}>
      <div className={styles.mktAgreementtPopup}>
        {/* Title */}
        <div className={styles.mktAgreementtTitleArea}>
          <span className={styles.mktAgreementtTitle}>{TnCData[props.name].title}</span>
          <button className={styles.mktAgreementtCancel} onClick={handlePopupClick} name={props.name}>
            <img src='/cancel.png' alt='cancel' className={styles.cancelImg} name={props.name} />
          </button>
        </div>
        {/* Body */}
        <div
          className={styles.mktAgreementtContent}
          dangerouslySetInnerHTML={{ __html: TnCData[props.name].content }}
        />
      </div>
    </div>
  );
};

export default MktAgreement;
